// import "../../assets/css/SalesBill.css";
// import ApiUrl from "./../Environment/ApiUrl";
// import axios from "axios";
// import { Navigate, useParams } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { useNavigate } from 'react-router-dom';

// const SalesBill = () => {
//   const { sales_no } = useParams();
//   const [salesData, setSalesData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//  const navigate = useNavigate(); // hook called inside component

//   useEffect(() => {
//     if (sales_no) {
//       fetchSalesData();
//     }
//   }, [sales_no]);

//   const fetchSalesData = async () => {
//     try {
//       setLoading(true);
//       console.log("Fetching for sales_no:", sales_no);

//       const response = await axios.get(
//         `${ApiUrl}/Api/sales.php?sales_no=${sales_no}`
//       );

//       console.log("API response:", response.data);

//       const filteredData = response.data.data?.find(
//         (item) => item.sales_no === sales_no
//       );
//       console.log("Filtered data:", filteredData);

//       if (filteredData) {
//         setSalesData(filteredData);
//       } else {
//         setError(`No sales data found for sales number: ${sales_no}`);
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       setError("Failed to fetch sales data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Format date from YYYY-MM-DD to DD-MMM-YYYY
//   const formatDate = (dateString) => {
//     if (!dateString) return "";

//     const date = new Date(dateString);
//     const options = { year: "numeric", month: "short", day: "2-digit" };
//     return date.toLocaleDateString("en-US", options);
//   };

//   // Function to convert number to words for amount display
//   const numberToWords = (num) => {
//     // This is a simplified version - you might want to use a library for this
//     const ones = [
//       "",
//       "One",
//       "Two",
//       "Three",
//       "Four",
//       "Five",
//       "Six",
//       "Seven",
//       "Eight",
//       "Nine",
//       "Ten",
//       "Eleven",
//       "Twelve",
//       "Thirteen",
//       "Fourteen",
//       "Fifteen",
//       "Sixteen",
//       "Seventeen",
//       "Eighteen",
//       "Nineteen",
//     ];
//     const tens = [
//       "",
//       "",
//       "Twenty",
//       "Thirty",
//       "Forty",
//       "Fifty",
//       "Sixty",
//       "Seventy",
//       "Eighty",
//       "Ninety",
//     ];

//     if (num === 0) return "Zero";

//     const convertLessThanThousand = (num) => {
//       if (num < 20) return ones[num];
//       const ten = Math.floor(num / 10);
//       const unit = num % 10;
//       return tens[ten] + (unit ? " " + ones[unit] : "");
//     };

//     const numStr = num.toString();
//     const numFloat = parseFloat(numStr);
//     const intPart = Math.floor(numFloat);
//     const decimalPart = Math.round((numFloat - intPart) * 100);

//     let result = "";
//     if (intPart >= 100000) {
//       result +=
//         convertLessThanThousand(Math.floor(intPart / 100000)) + " Lakh ";
//       num = intPart % 100000;
//     }

//     if (intPart >= 1000) {
//       result +=
//         convertLessThanThousand(Math.floor(intPart / 1000)) + " Thousand ";
//       num = intPart % 1000;
//     }

//     if (intPart >= 100) {
//       result +=
//         convertLessThanThousand(Math.floor(intPart / 100)) + " Hundred ";
//       num = intPart % 100;
//     }

//     if (intPart > 0) {
//       result += convertLessThanThousand(intPart % 100);
//     }

//     return result.trim() + " Only";
//   };

//   // Calculate totals from item list
//   const calculateTotals = () => {
//     if (!salesData?.item_list)
//       return {
//         totalQty: 0,
//         totalWeight: 0,
//         totalAmount: 0,
//       };

//     return salesData.item_list.reduce(
//       (acc, item) => {
//         acc.totalQty += parseInt(item.quantity) || 0;
//         acc.totalWeight += parseFloat(item.weight) || 0;
//         acc.totalAmount += parseFloat(item.amount) || 0;
//         return acc;
//       },
//       { totalQty: 0, totalWeight: 0, totalAmount: 0 }
//     );
//   };

//   if (loading) return <div>Loading sales data...</div>;
//   if (error) return <div>{error}</div>;
//   if (!salesData) return <div>No sales data available</div>;

//   const { totalQty, totalWeight, totalAmount } = calculateTotals();
//   const formattedDate = formatDate(salesData.sales_date);
//   const currentTime = new Date().toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });

//   return (
//     <div className="bill-container">
//       {/* Print Button (visible only on screen) */}
//       <button className="print-btn no-print" onClick={() => window.print()}>
//         Print Bill
//       </button>
//        <button className="cancel-btn no-print" onClick={() => navigate('/sales')}>
//       cancel
//     </button>

//       {/* Header Section */}
//       <div className="header-section">
//         <div className="invoice-title mt-1">
//           <p>INVOICE</p>
//         </div>
//         <div className="company-info">
//           <h4>TIRUPUR JEWELLERY</h4>
//           <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
//           <p>E-Mail : sales@tirupurjewellery.com</p>
//           <p>Ph: 04272233807, website: tirupurjewellery.com</p>
//         </div>
//         <div className="logo-container">
//           <img
//             src={require("../../assets/images/Final logo c.png")}
//             alt="TIRIPUR Logo"
//             className="logo"
//           />
//         </div>
//       </div>

//       <hr className="divider" />

//       {/* Invoice Details Section */}
//       <div className="details-section">
//         <div className="customer-info">
//           <div className="customer-details">
//             <p>{salesData.customer_data.name}</p>
//             <p>{salesData.customer_data.address}</p>
//             <p>Cell: {salesData.customer_data.mobile}</p>
//             <p>Recipient GST: {salesData.tax}</p>
//           </div>
//         </div>
//         <div className="invoice-info">
//           <div className="info-row">
//             <span>Date</span>
//             <span>
//               : {formattedDate}/{currentTime}
//             </span>
//           </div>
//           <div className="info-row">
//             <span>Bill No</span>
//             <span>: {salesData.sales_no}</span>
//           </div>
//           <div className="info-row">
//             <span>Gold</span>
//             <span>
//               : ₹{parseFloat(salesData.item_list?.[0]?.rate || 0).toFixed(2)}/g
//             </span>
//           </div>
//           <div className="info-row">
//             <span>Silver</span>
//             <span>: ₹91.00/g</span>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table-section">
//         <table className="bill-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Description</th>
//               <th>Purity</th>
//               <th>Qty</th>
//               <th>Making charge</th>
//               <th>Making wastage</th>
//               <th>Net Wt</th>
//               <th>Value</th>
//             </tr>
//           </thead>
//           <tbody>
//             {salesData.item_list &&
//               salesData.item_list.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>
//                     {item.item}
//                     <br />
//                     {item.category} - {item.action_type}
//                     <br />
//                     MC+{item.making_wastage_percentage} @
//                     {parseFloat(item.rate).toFixed(2)}
//                   </td>
//                   <td>{item.category === "Gold" ? "22KT" : "N/A"}</td>
//                   <td>{item.quantity}</td>

//                   <td>{parseFloat(item.making_charges).toFixed(3)}</td>
//                   <td>{parseFloat(item.making_wastage).toFixed(3)}</td>
//                   <td>{parseFloat(item.weight).toFixed(3)}</td>
//                   <td>{parseFloat(item.amount).toFixed(2)}</td>
//                 </tr>
//               ))}
//           </tbody>
//           <tfoot>
//             <tr className="table-footer">
//               <th colSpan="4">Total</th>
//               <th>{totalQty}</th>
//               <th>{totalWeight.toFixed(3)}</th>
//               <th>{totalWeight.toFixed(3)}</th>
//               <th>{totalAmount.toFixed(2)}</th>
//             </tr>
//           </tfoot>
//         </table>
//       </div>

//       <div className="details-section">
//         <div className="customer-info">
//           <div className="amount-in-words">
//             <p>(Rupees: {numberToWords(parseFloat(salesData.total))})</p>
//           </div>
//           <p>*Terms & Conditions</p>
//           <p className="paragraph-cont">
//             All jewellery items sold by TIRUPUR JEWELLERY are guaranteed to be
//             genuine and accurately metal purity and gemstone specifications.
//           </p>
//         </div>
//         <div className="invoice-info">
//           <div className="totals-section">
//             <div className="totals-grid">
//               <div className="total-row">
//                 <span>Sub Total</span>
//                 <span>{parseFloat(salesData.sub_total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Discount</span>
//                 <span>{parseFloat(salesData.discount_value).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 {/* <span>Tax ({salesData.tax_percentage}%)</span>
//                 <span>{parseFloat(salesData.tax).toFixed(2)}</span> */}

//                 <span>Tax ({salesData.tax}%)</span>
//                 <span>{parseFloat(salesData.tax_percentage).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>RoundOff</span>
//                 <span>{parseFloat(salesData.round_off).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Net Total</span>
//                 <span>{parseFloat(salesData.total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Payment Type</span>
//                 <span>
//                   {salesData.payment_history?.[0]?.payment_type || "N/A"}
//                 </span>
//               </div>
//               <div className="total-row highlight">
//                 <span>TOTAL</span>
//                 <span>{parseFloat(salesData.total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Paid</span>
//                 <span>{parseFloat(salesData.paid).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Balance</span>
//                 <span>{parseFloat(salesData.balance).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Exchange Old</span>
//                 <span>
//                   {parseFloat(salesData.exchange_old_value).toFixed(2)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <hr className="divider" />

//       {/* Footer Section */}
//       <div className="footer-section">
//         <div className="signatures">
//           <div className="customer-sign">
//             <p>Signature of the Purchaser</p>
//           </div>

//           <div className="">
//             <p className="footer-notes">--- Thank You Visit Again ---</p>
//             <div className="alaan">
//               <p>Developed by Aalan Tech Soft - Salem</p>
//             </div>
//           </div>

//           <div className="company-sign">
//             <p>FOR TIRUPUR JEWELLERY </p>
//             <p>Signature of the Seller</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesBill;

// import "../../assets/css/SalesBill.css";
// import ApiUrl from "./../Environment/ApiUrl";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";

// const SalesBill = () => {
//   const { sales_no } = useParams();
//   const [salesData, setSalesData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const navigate = useNavigate();

//   useEffect(() => {
//     if (sales_no) {
//       fetchSalesData();
//     }
//   }, [sales_no]);

//   const fetchSalesData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/sales.php?sales_no=${sales_no}`);
//       const filteredData = response.data.data?.find(item => item.sales_no === sales_no);

//       if (filteredData) {
//         setSalesData(filteredData);
//       } else {
//         setError(`No sales data found for sales number: ${sales_no}`);
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       setError("Failed to fetch sales data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const options = { year: "numeric", month: "short", day: "2-digit" };
//     return date.toLocaleDateString("en-US", options);
//   };

//  const numberToWords = (num) => {
//   if (isNaN(num) || num === null || num === undefined) return "";

//   const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
//   const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

//   num = parseFloat(num);
//   if (num === 0) return "Zero";

//   const convertLessThanThousand = (n) => {
//     if (n < 20) return ones[n];
//     const ten = Math.floor(n / 10);
//     const unit = n % 10;
//     return tens[ten] + (unit ? " " + ones[unit] : "");
//   };

//   let result = "";
//   let intPart = Math.floor(num);
//   let decimalPart = Math.round((num - intPart) * 100);

//   // Handle lakhs
//   if (intPart >= 100000) {
//     const lakhs = Math.floor(intPart / 100000);
//     result += convertLessThanThousand(lakhs) + " Lakh ";
//     intPart %= 100000;
//   }

//   // Handle thousands
//   if (intPart >= 1000) {
//     const thousands = Math.floor(intPart / 1000);
//     result += convertLessThanThousand(thousands) + " Thousand ";
//     intPart %= 1000;
//   }

//   // Handle hundreds
//   if (intPart >= 100) {
//     const hundreds = Math.floor(intPart / 100);
//     result += convertLessThanThousand(hundreds) + " Hundred ";
//     intPart %= 100;
//   }

//   // Handle remaining amount
//   if (intPart > 0) {
//     result += convertLessThanThousand(intPart);
//   }

//   // Handle decimal part (paise)
//   if (decimalPart > 0) {
//     result += " and " + convertLessThanThousand(decimalPart) + " Paise";
//   }

//   return result.trim() + " Only";
// };

//   const calculateTotals = () => {
//     if (!salesData?.item_list) return { totalQty: 0, totalWeight: 0, totalAmount: 0 };

//     return salesData.item_list.reduce(
//       (acc, item) => {
//         acc.totalQty += parseInt(item.quantity) || 0;
//         acc.totalWeight += parseFloat(item.weight) || 0;
//         acc.totalAmount += parseFloat(item.amount) || 0;
//         return acc;
//       },
//       { totalQty: 0, totalWeight: 0, totalAmount: 0 }
//     );
//   };

//   if (loading) return <div>Loading sales data...</div>;
//   if (error) return <div>{error}</div>;
//   if (!salesData) return <div>No sales data available</div>;

//   const { totalQty, totalWeight, totalAmount } = calculateTotals();
//   const formattedDate = formatDate(salesData.sales_date);
//   const currentTime = new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });

//   return (
//     <div className="bill-container">
//       <button className="print-btn no-print" onClick={() => window.print()}>
//         Print Bill
//       </button>
//       <button className="cancel-btn no-print" onClick={() => navigate('/sales')}>
//         Cancel
//       </button>

//       <div className="header-section">

//            <div className="logo-container">
//           <img
//             src={require("../../assets/images/Final logo c.png")}
//             alt="TIRIPUR Logo"
//             className="logo"
//           />
//         </div>
//         <div className="company-info">
//           <h4>TIRUPUR JEWELLERY</h4>
//           <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
//           <p>Ph: 04272233807</p>
//         </div>
//        <div className="invoice-title mt-1">
//           <p>INVOICE</p>
//         </div>
//       </div>

//       <hr className="divider" />

//       <div className="details-section">
//         <div className="customer-info">
//           <div className="customer-details">
//             <p>{salesData.customer_data.name}</p>
//             <p>{salesData.customer_data.address}</p>
//             <p>Cell: {salesData.customer_data.mobile}</p>
//             {/* ✅ Conditional GST display */}
//             {salesData.tax && <p>Recipient GST: {salesData.tax}%</p>}
//           </div>
//         </div>
//         <div className="invoice-info">
//           <div className="info-row">
//             <span>Date</span>
//             <span>: {formattedDate}/{currentTime}</span>
//           </div>
//           <div className="info-row">
//             <span>Bill No</span>
//             <span>: {salesData.sales_no}</span>
//           </div>
//           <div className="info-row">
//             <span>Gold</span>
//             <span>: ₹{parseFloat(salesData.item_list?.[0]?.rate || 0).toFixed(2)}/g</span>
//           </div>
//           <div className="info-row">
//             <span>Silver</span>
//             <span>: ₹91.00/g</span>
//           </div>
//         </div>
//       </div>

//       <div className="table-section">
//         <table className="bill-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Description</th>
//               <th>Purity</th>
//               <th>Qty</th>
//               <th>Making charge</th>
//               <th>Making wastage</th>
//               <th>Net Wt</th>
//               <th>Value</th>
//             </tr>
//           </thead>
//           <tbody>
//             {salesData.item_list &&
//               salesData.item_list.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>
//                     {item.item}
//                     <br />
//                     {item.category} - {item.action_type}
//                     <br />
//                     MC+{item.making_wastage_percentage} @ {parseFloat(item.rate).toFixed(2)}
//                   </td>
//                   <td>{item.category === "Gold" ? "22KT" : "N/A"}</td>
//                   <td>{item.quantity}</td>
//                   <td>{parseFloat(item.making_charges).toFixed(3)}</td>
//                   <td>{parseFloat(item.making_wastage).toFixed(3)}</td>
//                   <td>{parseFloat(item.weight).toFixed(3)}</td>
//                   <td>{parseFloat(item.amount).toFixed(2)}</td>
//                 </tr>
//               ))}
//           </tbody>
//           <tfoot>
//             <tr className="table-footer">
//               <th colSpan="4">Total</th>
//               <th>{totalQty}</th>
//               <th>{totalWeight.toFixed(3)}</th>
//               <th>{totalWeight.toFixed(3)}</th>
//               <th>{totalAmount.toFixed(2)}</th>
//             </tr>
//           </tfoot>
//         </table>
//       </div>

//       <div className="details-section">
//         <div className="customer-info">
//           <div className="amount-in-words">
//             <p>(Rupees: {numberToWords(parseFloat(salesData.total))})</p>
//           </div>
//           <p>*Terms & Conditions</p>
//           <p className="paragraph-cont">
//             All jewellery items sold by TIRUPUR JEWELLERY are guaranteed to be
//             genuine and accurately metal purity and gemstone specifications.
//           </p>
//         </div>
//         <div className="invoice-info">
//           <div className="totals-section">
//             <div className="totals-grid">
//               <div className="total-row">
//                 <span>Sub Total</span>
//                 <span>{parseFloat(salesData.sub_total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Discount</span>
//                 <span>{parseFloat(salesData.discount_value).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Tax ({salesData.tax}%)</span>
//                 <span>{parseFloat(salesData.tax_percentage).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>RoundOff</span>
//                 <span>{parseFloat(salesData.round_off).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Net Total</span>
//                 <span>{parseFloat(salesData.total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Payment Type</span>
//                 <span>{salesData.payment_history?.[0]?.payment_type || "N/A"}</span>
//               </div>
//               <div className="total-row highlight">
//                 <span>TOTAL</span>
//                 <span>{parseFloat(salesData.total).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Paid</span>
//                 <span>{parseFloat(salesData.paid).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Balance</span>
//                 <span>{parseFloat(salesData.balance).toFixed(2)}</span>
//               </div>
//               <div className="total-row">
//                 <span>Exchange Old</span>
//                 <span>{parseFloat(salesData.exchange_old_value).toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <hr className="divider" />

//       <div className="footer-section">
//         <div className="signatures">
//           <div className="customer-sign">
//             <p>Signature of the Purchaser</p>
//           </div>
//           <div>
//             <p className="footer-notes">--- Thank You Visit Again ---</p>
//             <div className="alaan">
//               <p>Developed by Aalan Tech Soft - Salem</p>
//             </div>
//           </div>
//           <div className="company-sign">
//             <p>FOR TIRUPUR JEWELLERY </p>
//             <p>Signature of the Seller</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesBill;

import "../../assets/css/SalesBill.css";
import ApiUrl from "./../Environment/ApiUrl";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const SalesBill = () => {
  const { sales_no } = useParams();
  const [salesData, setSalesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (sales_no) {
      fetchSalesData();
    }
  }, [sales_no]);

  const fetchSalesData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${ApiUrl}/Api/sales.php?sales_no=${sales_no}`
      );
      const filteredData = response.data.data?.find(
        (item) => item.sales_no === sales_no
      );

      if (filteredData) {
        setSalesData(filteredData);
      } else {
        setError(`No sales data found for sales number: ${sales_no}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError("Failed to fetch sales data");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  const numberToWords = (num) => {
    if (isNaN(num) || num === null || num === undefined) return "";

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    num = parseFloat(num);
    if (num === 0) return "Zero";

    const convertLessThanThousand = (n) => {
      if (n < 20) return ones[n];
      const ten = Math.floor(n / 10);
      const unit = n % 10;
      return tens[ten] + (unit ? " " + ones[unit] : "");
    };

    let result = "";
    let intPart = Math.floor(num);
    let decimalPart = Math.round((num - intPart) * 100);

    // Handle lakhs
    if (intPart >= 100000) {
      const lakhs = Math.floor(intPart / 100000);
      result += convertLessThanThousand(lakhs) + " Lakh ";
      intPart %= 100000;
    }

    // Handle thousands
    if (intPart >= 1000) {
      const thousands = Math.floor(intPart / 1000);
      result += convertLessThanThousand(thousands) + " Thousand ";
      intPart %= 1000;
    }

    // Handle hundreds
    if (intPart >= 100) {
      const hundreds = Math.floor(intPart / 100);
      result += convertLessThanThousand(hundreds) + " Hundred ";
      intPart %= 100;
    }

    // Handle remaining amount
    if (intPart > 0) {
      result += convertLessThanThousand(intPart);
    }

    // Handle decimal part (paise)
    if (decimalPart > 0) {
      result += " and " + convertLessThanThousand(decimalPart) + " Paise";
    }

    return result.trim() + " Only";
  };

  const calculateTotals = () => {
    if (!salesData?.item_list)
      return { totalQty: 0, totalWeight: 0, totalAmount: 0, totalMaking: 0, totalWastage: 0 };

    return salesData.item_list.reduce(
      (acc, item) => {
        acc.totalQty += parseInt(item.quantity) || 0;
        acc.totalWeight += parseFloat(item.weight) || 0;
        acc.totalAmount += parseFloat(item.amount) || 0;
        acc.totalMaking += parseFloat(item.making_charges) || 0;
        acc.totalWastage += parseFloat(item.making_wastage) || 0;
        return acc;
      },
      { totalQty: 0, totalWeight: 0, totalAmount: 0, totalMaking: 0, totalWastage: 0 }
    );
  };

  if (loading) return <div>Loading sales data...</div>;
  if (error) return <div>{error}</div>;
  if (!salesData) return <div>No sales data available</div>;

  const { totalQty, totalWeight, totalAmount, totalMaking, totalWastage } = calculateTotals();
  const formattedDate = formatDate(salesData.sales_date);
  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  // Corrected Amount Summary calculations
  const subTotal =
    parseFloat(
      salesData.item_list?.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      )
    ) || 0;
  const discountPercentage = parseFloat(salesData.discount) || 0;
  const discountValue = (subTotal * discountPercentage) / 100;
  const netTotalBeforeTax = subTotal - discountValue;
  const taxPercentage = parseFloat(salesData.tax) || 0;
  const taxAmount = (netTotalBeforeTax * taxPercentage) / 100;
  const roundOff = parseFloat(salesData.round_off) || 0;
  const grandTotal = netTotalBeforeTax + taxAmount + roundOff;

  return (
    <div className="bill-container">
      <button className="print-btn no-print" onClick={() => window.print()}>
        Print Bill
      </button>
      <button
        className="cancel-btn no-print"
        onClick={() => navigate("/sales")}
      >
        Cancel
      </button>

      <div className="header-section d-flex justify-content-between align-items-center">
        <div className="logo-container">
          <img
            src={require("../../assets/images/Final logo c .png")}
            alt="TIRIPUR Logo"
            className="logo"
            style={{ width: "100px" }}
          />
        </div>
        <div className="company-info text-center">
          <h4>TIRUPUR JEWELLERY</h4>
          <p>3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
          <p>Ph: 04272233807</p>
        </div>
        <div className="invoice-title">
          <p className="m-0 fw-bold">INVOICE</p>
        </div>
      </div>

      <hr className="divider" />

      <div className="details-section">
        <div className="customer-info">
          <div className="customer-details">
            <p>{salesData.customer_data.name}</p>
            <p>{salesData.customer_data.address}</p>
            <p>Cell: {salesData.customer_data.mobile}</p>
            {salesData.tax && <p>Recipient GST: {salesData.tax}%</p>}
          </div>
        </div>
        <div className="invoice-info">
          <div className="info-row">
            <span>Date</span>
            <span>
              : {formattedDate}/{currentTime}
            </span>
          </div>
          <div className="info-row">
            <span>Bill No</span>
            <span>: {salesData.sales_no}</span>
          </div>
          <div className="info-row">
            <span>Gold</span>
            <span>
              : ₹{parseFloat(salesData.item_list?.[0]?.rate || 0).toFixed(2)}/g
            </span>
          </div>
          <div className="info-row">
            <span>Silver</span>
            <span>
              : ₹{parseFloat(
                salesData.item_list?.find(i => i.category === "Silver")?.rate ||
                salesData.item_list?.find(i => i.category === "silver")?.rate || 0
              ).toFixed(2)}/g
            </span>
          </div>
        </div>
      </div>

      <div className="table-section">
        <table className="bill-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Weight(g)</th>
              <th>Rate</th>
              <th>Making Cost</th>
              <th>Wastage</th>
              <th>GST</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {salesData.item_list &&
              salesData.item_list.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {item.item_name_tamil
                      ? `${item.item} / ${item.item_name_tamil}`
                      : item.item}
                    {item.category ? ` (${item.category})` : ""}
                  </td>
                  <td>{item.quantity}</td>
                  <td>{parseFloat(item.weight).toFixed(3)}</td>
                  <td>{parseFloat(item.rate || 0).toFixed(2)}</td>
                  <td>{parseFloat(item.making_charges || 0).toFixed(3)}</td>
                  <td>{parseFloat(item.making_wastage || 0).toFixed(3)}</td>
                  <td>{item.making_wastage_percentage ? `${item.making_wastage_percentage}%` : "-"}</td>
                  <td>{parseFloat(item.amount).toFixed(2)}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="table-footer">
              <th colSpan="2">Total</th>
              <th>{totalQty}</th>
              <th>{totalWeight.toFixed(3)}</th>
              <th>-</th>
              <th>{totalMaking.toFixed(3)}</th>
              <th>{totalWastage.toFixed(3)}</th>
              <th>-</th>
              <th>{totalAmount.toFixed(2)}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="details-section">
        <div className="customer-info">
          <div className="amount-in-words">
            <p>(Paid Amount: {numberToWords(grandTotal)})</p>
          </div>
          <p>*Terms & Conditions</p>
          <p className="paragraph-cont">
            All jewellery items sold by Tirupur Jewellery are guaranteed to be
            genuine and accurately metal purity and gemstone specifications.
          </p>
        </div>
        <div className="invoice-info">
          <div className="totals-section">
            <div className="totals-grid">
              <div className="total-row">
                <span>Sub Total</span>
                <span>{subTotal.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Discount ({discountPercentage}%)</span>
                <span>{discountValue.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Net Amount</span>
                <span>{netTotalBeforeTax.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Tax ({taxPercentage}%)</span>
                <span>{taxAmount.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Round Off</span>
                <span>{roundOff.toFixed(2)}</span>
              </div>
              <div className="total-row highlight">
                <span>Grand Total</span>
                <span>{grandTotal.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Payment Type</span>
                <span>
                  {salesData.payment_history?.[0]?.payment_type || "N/A"}
                </span>
              </div>
              <div className="total-row">
                <span>Paid</span>
                <span>{parseFloat(salesData.paid || 0).toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Balance</span>
                <span>{parseFloat(salesData.balance || 0).toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Exchange Old</span>
                <span>
                  {parseFloat(salesData.exchange_old_value || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      <div className="footer-section">
        <div className="signatures">
          <div className="customer-sign">
            <p>Signature of the Purchaser</p>
          </div>
          <div>
            <p className="footer-notes">--- Thank You Visit Again ---</p>
            <div className="alaan">
              <p>Developed by Aalan Tech Soft - Salem</p>
            </div>
          </div>
          <div className="company-sign">
            <p>FOR TIRUPUR JEWELLERY </p>
            <p>Signature of the Seller</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesBill;
